module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-256x256-4fbf6dc2f93c08c2f79aea5acd089d98.png";